$('.exchange_tab span').click(function () {
  $(this).addClass('active').siblings('span').removeClass('active')
  $('.container_green').removeClass('active').eq($(this).index()).addClass('active')
});